import React from 'react';
import { Link } from 'react-router-dom';

export default class PrimaryButton extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("PrimaryButton", this.props)
		return (
			<Link to={this.props.url}>
				<button
					type="button"
					style={this.props.style}
					className={
						'my-3 bg-gray-300 text-center rounded-md' +
						(this.props.onShowcase ? ' md:w-40 ' : ' w-full')
					}
					onClick={this.props.onClick}
				>
					<p className="text-lg py-2 px-8 text-black hover:underline">
						{this.props.label}
					</p>
				</button>
			</Link>
		);
	}
}
